import styled from "styled-components";

export const CMCarousel = styled.div(props => ({
    "& .swiper": {
        paddingBottom: '2rem',
        [`@media (min-width: 2000px)`]: {
            justifyContent:"center", 
            "& div": {
              width: "30vh !important",
              height: "auto !important"
            },
        },

        "& .swiper-slide": {
            height: 'auto',
            [`@media (min-width: 2000px)`]: {
                "& img": {
                  width: "100%",
                  height: "auto"
                },
                "& h5": {
                  fontSize:"3vh"
                },
            },
        }
    }
}));